<template>
  <CommonWrapperLayout>
    <TheHeader />

    <RouterView />

    <TheFooter />
  </CommonWrapperLayout>
</template>

<script setup>
import CommonWrapperLayout from '@/components/layout/CommonWrapperLayout.vue';
import TheHeader from '@/components/header/TheHeader.vue';
import TheFooter from '@/components/footer/TheFooter.vue';
</script>
